import React, { useRef, useEffect } from 'react';
import { getNdviColor } from '../../utils/ndviColors';
import { getNdmiColor } from '../../utils/ndmiColors';
import { useTranslation } from 'react-i18next';
import './MapTimeline.css';

const MapTimeline = ({ data, onSelect, selectedDate, activeIndex = 'NDVI' }) => {
    const { i18n } = useTranslation();
    const currentLocale = i18n.language?.startsWith('en') ? 'en-US' : 'tr-TR';
    const scrollRef = useRef(null);
    const lastItemRef = useRef(null);

    // Auto-scroll to latest (last) date on mount or when data changes
    useEffect(() => {
        if (lastItemRef.current && scrollRef.current) {
            lastItemRef.current.scrollIntoView({ behavior: 'smooth', inline: 'end', block: 'nearest' });
        }
    }, [data]);

    if (!data || data.length === 0) return null;

    return (
        <div className="map-timeline-container">
            <div className="map-timeline-scroll" ref={scrollRef}>
                {data.map((item, index) => {
                    const isSelected = selectedDate === item.date;
                    const isLast = index === data.length - 1;
                    const date = new Date(item.date);

                    const value = activeIndex === 'NDVI' ? item.meanNdvi :
                        activeIndex === 'NDRE' ? item.meanNdre :
                            item.meanNdmi;
                    const displayValue = value !== undefined ? value : null;

                    const indexColor = activeIndex === 'NDMI' ?
                        (displayValue !== null ? getNdmiColor(displayValue) : '#ccc') :
                        (displayValue !== null ? getNdviColor(displayValue) : '#ccc');

                    return (
                        <div
                            key={index}
                            ref={isLast ? lastItemRef : null}
                            className={`timeline-item ${isSelected ? 'active' : ''}`}
                            onClick={() => onSelect(item)}
                            title={`${activeIndex}: ${displayValue?.toFixed(3) || 'N/A'}`}
                        >
                            <div className="item-bg" style={{ backgroundColor: `${indexColor}15` }}></div>
                            <div className="timeline-date">
                                <span className="day">{date.getDate()}</span>
                                <span className="month">{date.toLocaleDateString(currentLocale, { month: 'short' })}</span>
                            </div>
                            <div className="ndvi-value" style={{ color: indexColor }}>
                                {displayValue?.toFixed(2) || '---'}
                            </div>
                            <div className="health-dot" style={{ background: indexColor }}></div>
                            <div className="timeline-bar"></div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default MapTimeline;
